import React, { useState } from "react";
import "containers/CartOverview/CartFooter/CartFooter.css";
import useCart from "hooks/useCart";
import PropTypes from "prop-types";
import Button from "components/Button/Button";
import BottomUpModal from "components/BottomUpModal/BottomUpModal";
import LoginForm from "components/LoginForm/LoginForm";
import { renderPriceWithSymbol } from "utils/commonMethods";
import { Link } from "react-router-dom";
import { APP_ROUTES } from "constants/routes";
import { withRouter } from "react-router";
import useAuthentication from "hooks/useAuthentication";
import { useSelector } from "react-redux";

//Handles user authentication & action buttons of cart page.
function CartFooter({ componentTexts, history }) {
  const [showUserLoginModal, setShowUserLoginModal] = useState(false);
  const { userIsLoggedIn } = useAuthentication();
  const { currentCartItems, cartTotalPrice, totalDiscountPrice } = useCart();

  const toggleUserLoginModal = function () {
    return setShowUserLoginModal(!showUserLoginModal);
  };

  const handleCheckoutClick = function () {
    // if (!userIsLoggedIn()) {
    //   return toggleUserLoginModal();
    // } else {
    //If already logged in, redirect user to checkout page.
    return history.push(APP_ROUTES.CHECKOUT_PAGE.url);
    // }
  };

  const cartCouponDetails = useSelector(
    (state) => state.cartReducer.couponDetails
  );

  //Do not show footer if there are no products in cart.
  if (currentCartItems.length === 0) {
    return <React.Fragment></React.Fragment>;
  }

  return (
    <div className="cart-footer">
      <div className="cart-footer__buy-overview">
        <h4 className="sub-head cart-footer__sub-total-lable">Sub total :</h4>
        <span className="sub-head cart-footer__sub-total-price">
          {renderPriceWithSymbol(cartTotalPrice)}
        </span>
        {totalDiscountPrice > 0 && (
          <React.Fragment>
            <h4 className="sub-head cart-footer__discount-label">
              {componentTexts.cart_page_discount_label}
            </h4>
            <span className="sub-head cart-footer__discount-price">
              -{renderPriceWithSymbol(totalDiscountPrice)}
            </span>
          </React.Fragment>
        )}

        {cartCouponDetails && (
          <React.Fragment>
            <h4 className="sub-head cart-footer__coupon-label">
              {componentTexts.cart_page_coupon_applied_label}
            </h4>
            <span className="sub-head cart-footer__coupon-price">
              -{renderPriceWithSymbol(cartCouponDetails.dVal)}
            </span>
          </React.Fragment>
        )}
      </div>
      <hr />
      <div className="cart-footer__buy-overview">
        <h4 className="main-head cart-footer__buy-label">
          {componentTexts.cart_page_total_label}
        </h4>
        <span className="cart-footer__buy-price">
          {renderPriceWithSymbol(
            cartTotalPrice - totalDiscountPrice - (cartCouponDetails?.dVal || 0)
          )}
        </span>
      </div>
      <div className="cart-footer__checkout">
        <Button onClick={handleCheckoutClick}>
          {componentTexts.cart_page_checkout_button_text}
        </Button>
        <Link to={APP_ROUTES.HOME_PAGE.url}>
          {componentTexts.cart_page_add_more_button_text}
        </Link>
      </div>

      <BottomUpModal
        open={showUserLoginModal}
        closeHandler={toggleUserLoginModal}
      >
        {showUserLoginModal && <LoginForm />}
      </BottomUpModal>
    </div>
  );
}

CartFooter.propTypes = {
  componentTexts: PropTypes.object.isRequired,
};

export default withRouter(CartFooter);
